// Thumbnail/ThumbnailPreview.js

import React from 'react';
import { hexToRgb } from './thumbnailUtils';

function ThumbnailPreview({ 
    settings, 
    backgroundImage, 
    effectsLayerRef,
    language 
}) {
    // 배경 스타일 생성
    const getBackgroundStyle = () => {
        let background = '';
        
        if (backgroundImage) {
            const bgOpacity = settings.bgOpacity / 100;
            background = `linear-gradient(rgba(${hexToRgb(settings.bgColor1)}, ${bgOpacity}), rgba(${hexToRgb(settings.bgColor2)}, ${bgOpacity})), url(${backgroundImage})`;
            return {
                background,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            };
        } else {
            switch(settings.bgType) {
                case 'gradient':
                    background = `linear-gradient(135deg, ${settings.bgColor1}, ${settings.bgColor2})`;
                    break;
                case 'radial':
                    background = `radial-gradient(circle, ${settings.bgColor1}, ${settings.bgColor2})`;
                    break;
                case 'solid':
                    background = settings.bgColor1;
                    break;
                case 'pattern':
                    background = `linear-gradient(45deg, ${settings.bgColor1} 25%, transparent 25%), 
                                 linear-gradient(-45deg, ${settings.bgColor1} 25%, transparent 25%), 
                                 linear-gradient(45deg, transparent 75%, ${settings.bgColor1} 75%), 
                                 linear-gradient(-45deg, transparent 75%, ${settings.bgColor1} 75%)`;
                    return {
                        background,
                        backgroundSize: '20px 20px',
                        backgroundColor: settings.bgColor2
                    };
                default:
                    background = settings.bgColor1;
            }
            return { background };
        }
    };

    // 텍스트 그림자 스타일
    const getTextShadowStyle = () => ({
        textShadow: `${settings.textShadow}px ${settings.textShadow}px ${settings.textShadow * 2}px rgba(0,0,0,0.7)`
    });

    return (
        <div 
            className="thumbnail-preview"
            style={{
                ...getBackgroundStyle(),
                color: settings.textColor
            }}
        >
            <div ref={effectsLayerRef} className="effects-layer"></div>
            <div className="text-content">
                <div 
                    style={{
                        fontSize: '48px', 
                        marginBottom: '10px',
                        ...getTextShadowStyle()
                    }}
                >
                    {settings.mainIcon}
                </div>
                <h2 
                    style={{
                        margin: '10px 0', 
                        fontSize: `${settings.fontSize}px`,
                        ...getTextShadowStyle()
                    }}
                >
                    {settings.mainTitle}
                </h2>
                <p 
                    style={{
                        margin: '5px 0', 
                        fontSize: '24px', 
                        opacity: 0.9,
                        ...getTextShadowStyle()
                    }}
                >
                    {settings.subTitle}
                </p>
                <p 
                    style={{
                        margin: '5px 0', 
                        fontSize: '18px', 
                        opacity: 0.8,
                        ...getTextShadowStyle()
                    }}
                >
                    {settings.artist}
                </p>
            </div>
        </div>
    );
}

export default ThumbnailPreview;